import { environment } from 'environments/environment';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';

import { RouterModule } from '@angular/router';
import { appRoutes } from './app.routes';
import { AppComponent } from './app.component';
import { AppMainModule } from './mainModule/appMain.module';
import { LoginModule } from './login/login.module';
import { CommonModule } from '@angular/common'; 
import { UiModule } from './ui/ui.module';
import { APP_CONFIG, PROJECT_CONFIG, AppConfig, ProjectConfig } from './app.config';
// config assetów
import { ASSETS_CONFIG, AssetsConfig } from './assets.config';

import {
  AuthModule,
  OidcSecurityService,
  OpenIDImplicitFlowConfiguration,
  OidcConfigService,
  AuthWellKnownEndpoints
} from 'angular-auth-oidc-client';

export function loadConfig(oidcConfigService: OidcConfigService) {
  //console.log('APP_INITIALIZER STARTING');
  return () => oidcConfigService.load_using_stsServer('https://test2-organization.com.pl');
}

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    RouterModule.forRoot(appRoutes, {useHash: true}),
    CommonModule,
    UiModule,
    // AuthModule.forRoot()
  ],
  providers: [
    { provide: APP_CONFIG, useValue: AppConfig },
    { provide: PROJECT_CONFIG, useValue: ProjectConfig },
    { provide: ASSETS_CONFIG, useValue: AssetsConfig },
    // OidcConfigService,
    // {
    //     provide: APP_INITIALIZER,
    //     useFactory: loadConfig,
    //     deps: [OidcConfigService],
    //     multi: true
    // },
    // OidcSecurityService
  ],
  
  bootstrap: [AppComponent]
})
export class AppModule 
{ 

  /*constructor(
    private oidcSecurityService: OidcSecurityService,
    private oidcConfigService: OidcConfigService,
) {
    this.oidcConfigService.onConfigurationLoaded.subscribe(() => {

        //console.log(this.oidcConfigService.clientConfiguration);
        //let domain = "http://localhost:9010";
        let domain = "https://futurebanking.pl";

        let openIDImplicitFlowConfiguration = new OpenIDImplicitFlowConfiguration();
        openIDImplicitFlowConfiguration.stsServer = 'https://test2-organization.com.pl'; //'https://login.microsoftonline.com/tfp/fabrikamb2c.onmicrosoft.com/b2c_1_susi/oauth2/v2.0/';
        openIDImplicitFlowConfiguration.redirect_url = domain+'/#/auth/action/redirect/login';
        openIDImplicitFlowConfiguration.client_id = 'N0N1-KOwZCP7bvztqqE_8A';
        openIDImplicitFlowConfiguration.response_type = 'id_token token';
        openIDImplicitFlowConfiguration.scope = 'openid email profile';
        openIDImplicitFlowConfiguration.post_logout_redirect_uri = domain;
        openIDImplicitFlowConfiguration.post_login_route = '';
        openIDImplicitFlowConfiguration.forbidden_route = '';
        openIDImplicitFlowConfiguration.unauthorized_route = '';
        openIDImplicitFlowConfiguration.auto_userinfo = false;
        openIDImplicitFlowConfiguration.log_console_warning_active = false;
        openIDImplicitFlowConfiguration.log_console_debug_active = false;
        openIDImplicitFlowConfiguration.max_id_token_iat_offset_allowed_in_seconds = 15;
        openIDImplicitFlowConfiguration.silent_renew_url = domain+"/#/auth/action/redirect/refresh";
        //:
        //console.log(openIDImplicitFlowConfiguration);
        const authWellKnownEndpoints = new AuthWellKnownEndpoints();
        authWellKnownEndpoints.setWellKnownEndpoints(this.oidcConfigService.wellKnownEndpoints);

        this.oidcSecurityService.setupModule(openIDImplicitFlowConfiguration, authWellKnownEndpoints);
    });

    //this.oidcSecurityService.
    //console.log('APP STARTING');
}
*/
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts